import { useLocation } from 'react-router-dom';
import SegmentAnalytics from 'ff/common/SegmentAnalytics';
import { getCurrentPage } from '../utils';

interface EventProperties {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

function getCurrentEnvironment(): string {
    const hostname = window.location.hostname;

    if (hostname === 'beta.foreflight.com') {
        return 'beta';
    } else if (hostname === 'plan.foreflight.com') {
        return 'production';
    }

    // Default to 'development' for local development or unknown hosts
    return 'development';
}

export function useAnalytics() {
    const location = useLocation();

    const logEvent = (eventName: string, properties?: EventProperties) => {
        const currentPage = getCurrentPage(location.pathname);
        const environment = getCurrentEnvironment();

        const enhancedProperties = {
            ...properties,
            currentPage,
            environment,
        };

        SegmentAnalytics.logEvent(eventName, enhancedProperties);
    };

    return { logEvent };
}
